import {
    Dispatch,
    ReactNode,
    SetStateAction,
    createContext,
    useContext,
    useMemo,
    useState,
} from 'react';
import { Campaign } from 'types/domain';

interface WithdrawFundsContextType {
    campaign: Campaign;
    transferSent: boolean;
    setTransferSent: Dispatch<SetStateAction<boolean>>;
}

const WithdrawFundsContext = createContext<WithdrawFundsContextType | undefined>(undefined);

interface WithdrawFundsProviderProps {
    campaign: Campaign;
    children: ReactNode;
}

const WithdrawFundsProvider = ({ campaign, children }: WithdrawFundsProviderProps) => {
    const [transferSent, setTransferSent] = useState(false);

    const ctx = useMemo(
        () => ({ campaign, transferSent, setTransferSent }),
        [campaign, transferSent, setTransferSent],
    );
    return <WithdrawFundsContext.Provider value={ctx}>{children}</WithdrawFundsContext.Provider>;
};

const useWithdrawFunds = () => {
    const context = useContext(WithdrawFundsContext);
    if (!context) {
        throw new Error('useWithdrawFunds must be used within a WithdrawFundsProvider');
    }
    return context;
};

export { WithdrawFundsContext, WithdrawFundsProvider, useWithdrawFunds };

export type { WithdrawFundsContextType, WithdrawFundsProviderProps };
